import { Factory } from '@mui/icons-material';
import { Box } from '@mui/material';
import Image from 'next/image';
import { FC } from 'react';

interface Props {
  url: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export const CompanyLogo: FC<Props> = ({ url, size = 'md' }) => {
  const width =
    size === 'xs' ? 40 : size === 'sm' ? 80 : size === 'md' ? 100 : 120;

  if (url) {
    return (
      <Image
        src={url}
        width={width}
        height={width}
        style={{
          borderRadius: '50%',
          objectFit: 'fill',
        }}
        alt="logo"
      />
    );
  } else {
    return (
      <Box
        width={width}
        height={width}
        bgcolor="#f2f2f2"
        borderRadius="50%"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Factory style={{ fontSize: '50px' }} htmlColor="gray" />
      </Box>
    );
  }
};
